import { Maybe } from 'types/graphqlTypes'
import { ICarrierApplication } from 'types/marketplace'
import { TRACKING_METHOD_TYPE } from 'types/tracking'

export const getDefaultTrackingMethod = (
  carrierApplication: Maybe<ICarrierApplication>
): TRACKING_METHOD_TYPE | undefined => {
  if (carrierApplication?.keepTruckinEnabled) {
    return TRACKING_METHOD_TYPE.keepTruckin
  }
  // `isEldApproved` is set to value of `is_p44_active?` in the BE serializer
  if (carrierApplication?.isEldApproved) {
    return TRACKING_METHOD_TYPE.project44
  }

  return TRACKING_METHOD_TYPE.fmsMobile
}
